import { DefaultPageHeader, FitContentPageLayout } from 'layouts';
import { EventFeedback, type EventFeedbackOptions } from 'features/events';
import type { CalendarSearchParamsOptions, CreateReminderParams } from '../types';
import { Content } from './content';
import { CreateReminder } from './create-reminder';
import { Header } from './header';

type P = {
  createReminderParams: CreateReminderParams;
  feedbackOptions: EventFeedbackOptions;
  getPathToEventDetail: (id: string) => string;
  navigateToEventDetail: (id: string) => Promise<void>;
  searchParamsOptions: CalendarSearchParamsOptions;
};

const Calendar = ({
  createReminderParams,
  feedbackOptions,
  getPathToEventDetail,
  navigateToEventDetail,
  searchParamsOptions,
}: P) => (
  <FitContentPageLayout cardProperties={{ shrinkedTop: true }} header={<DefaultPageHeader title="Calendar" />}>
    <EventFeedback {...feedbackOptions} />
    <CreateReminder {...createReminderParams} />
    <Header searchParamsOptions={searchParamsOptions} />
    <Content
      getPathToEventDetail={getPathToEventDetail}
      navigateToEventDetail={navigateToEventDetail}
      searchParamsOptions={searchParamsOptions}
    />
  </FitContentPageLayout>
);

export default Calendar;
